import styled from 'styled-components'

/**
 * 门户管理 应用列表-应用卡片-卡片标签
 *
 * @param param - 参数
 * @param param.unOpen - 是否未启用
 * @returns 组件
 */
export const TopTip: React.FC<{ unOpen?: boolean }> = ({ unOpen }) => {
  return (
    <Box unOpen={unOpen}>
      <TextBox unOpen={unOpen}>{unOpen ? '未启用' : '未设置'}</TextBox>
    </Box>
  )
}

const Box = styled.div<{ unOpen?: boolean }>`
  border: 30px solid ${(props) => (props.unOpen ? '#ffe8ba' : '#E1EBF0')};
  height: 0;
  width: 0;
  border-right-color: transparent;
  border-bottom-color: transparent;
  position: absolute;
  border-radius: 7px 0 0 0;
  margin-left: -16px;
  margin-top: -16px;
`

const TextBox = styled.div<{ unOpen?: boolean }>`
  color: ${(props) => (props.unOpen ? '#d26900' : '#455766')};

  text-align: center;
  text-shadow: rgba(255, 255, 255, 0.5) 0px 1px 0px;
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
  -ms-transform: rotate(-45deg);
  -o-transform: rotate(-45deg);
  position: absolute;
  padding: 10px 0;
  font-size: 12px;
  width: 100px;
  left: -60px;
  top: -28px;
`
